<h3>สมัครใช้บริการ</h3>
<form autocomplete="off" #registerNewUserForm="ngForm" class="uk-margin-small-bottom uk-text-left" novalidate (ngSubmit)="onSubmit()">
    <div>
        <label for="firstName" class="uk-form-label">ชื่อ</label>
        <div class="uk-form-controls uk-position-relative">
            <input id="firstName" class="uk-input uk-border-rounded" type="text" placeholder="กรุณาระบุชื่อของท่าน"
                autocomplete="off" name="firstName" #firstName="ngModel" [(ngModel)]="model().form.firstName.value"
                [(ngModel)]="model().form.firstName.value" [ngClass]="addClass(registerNewUserForm,'firstName')"
                [pattern]="regName" required />
            <small class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error" tabindex="-1"
                [ngClass]="addClass(registerNewUserForm,'firstName','msg')" *ngIf="firstName.errors">
                <span *ngIf="firstName.errors.required">กรุณาระบุชื่อของท่าน</span>
                <span *ngIf="firstName.errors && firstName.errors.pattern">ชื่อของคุณไม่ถูกหลัก</span>
            </small>
        </div>
    </div>
    <div>
        <label for="lastName" class="uk-form-label">นามสกุล</label>
        <div class="uk-form-controls uk-position-relative">
            <input id="lastName" class="uk-input uk-border-rounded" type="text" placeholder="กรุณาระบุนามสกุลของท่าน"
                autocomplete="off" name="lastName" #lastName="ngModel"
                [(ngModel)]="model().form.lastName.value" [ngClass]="addClass(registerNewUserForm,'lastName')"
                [pattern]="regName" required />
            <small class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error" tabindex="-1"
                [ngClass]="addClass(registerNewUserForm,'lastName','msg')">
                <span *ngIf="lastName.errors&& lastName.errors.required">กรุณาระบุนามสกุลของท่าน</span>
                <span *ngIf="lastName.errors && lastName.errors.pattern">นามสกุลของคุณไม่ถูกหลัก</span>
            </small>
        </div>
    </div>
    <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal">
        <button type="submit"
            class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
            [disabled]="registerNewUserForm.invalid">ถัดไป
        </button>
    </div>
    <div class="uk-text-center" *ngIf="invalidInformation">
        <p class="uk-text-center uk-text-meta uk-margin-small-bottom"><small>หากท่านต้องการแก้ไขข้อมูล
                กรุณาติดต่อ</small></p>
        <div><a href="tel:026336060" class="uk-h5"><img src="/assets/images/icon-tel.svg" uk-svg class="tel-icon"
                    width="15" height="15"> 0 2633 6060</a></div>
    </div>
</form>